<template>
  <IconButton bgColor="#16AFC7" width="11.5em" :svg="$assets.svg['courseMaterial_icon']" @click="click">
    Course Materials
  </IconButton>
</template>

<script>
import IconButton from '@/components/events/IconButton.vue';

export default {
  components: {
    IconButton,
  },

  methods: {
    click() {
      this.$emit('click');
    },
  },
};
</script>

<style scoped></style>
